<div class="flex items-center justify-center gap-2.5" (paste)="onPaste($event)">
  @for (digit of digits; track $index) {
    <input
      #otpField
      type="text"
      inputmode="numeric"
      autocomplete="one-time-code"
      maxlength="1"
      [disabled]="disabled()"
      [value]="digit"
      (input)="onInput($index, $event)"
      (keydown)="onKeyDown($index, $event)"
      class="h-12 w-11 rounded-lg border bg-[#0f1721] text-center text-lg font-bold text-[#eaf1fa] outline-none transition focus:border-[#9ab1cb] focus:shadow-[0_0_0_2px_rgba(154,177,203,0.2)] disabled:cursor-not-allowed disabled:opacity-60 sm:h-14 sm:w-12"
      [class.border-[#3f5168]]="!invalid()"
      [class.border-[rgba(255,125,125,0.7)]]="invalid()"
    />
  }
</div>
